﻿'use strict'
import { App, Action, View } from '../../config/app.js'
import * as Helper from '../../helper.js'
import { Modal } from '../../modal.js'

export default function ()
{
	App.Modal.SavedCartAddToCart = new Modal('SavedCartAddToCart', {
		actionOpenName: 'savedcart addtocart',
		onOpen: async (modal, data) =>
		{
			modal.view.model.clear()
			await App.Store.fetch('savedcart', data.id, { 'include': 'item,product', 'share': data.share || false })
				.then(model => modal.view.model.sync(model))
		},
		onActionAfter: () => setTimeout(() => document.querySelector('#cart-nav [data-toggle="dropdown"]').click()) // Show dropdown cart
	})

	// Process shared cart URLs
	document.addEventListener('app.ready', e =>
	{
		const qs = new URLSearchParams(location.search)
		const savedCart = qs.get('savedcart')
		const redirectUrl = '/register'

		if (savedCart != null)
		{
			if (Helper.hasRole('Guest'))
			{
				location.href = redirectUrl + '?ReturnUrl=' + encodeURIComponent('/?savedcart=' + savedCart.toUpperCase())
			}
			else
			{
				Action.cache('savedcart addtocart').run(document.body, { id: savedCart.toUpperCase(), share: true })
			}
		}
	})
}
